import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { HSTRoles } from '../../../components/hstRoles/HSTRoles';

interface HSTRolesAutocompleteProps {
    jobTitle: string;
    selectedRole: string;
    onChange: (jobTitle: string, role: string) => void;
    placeholder?: string;
}

function HSTRolesAutocomplete({ 
    jobTitle, 
    selectedRole, 
    onChange,
    placeholder = "Search HST roles..."
}: HSTRolesAutocompleteProps) {
    const roles = Object.values(HSTRoles).map(role => role.name);
    
    const handleChange = (_event: React.SyntheticEvent, value: string | null) => {
        onChange(jobTitle, value || '');
    };return (
        <Autocomplete
            value={selectedRole || null}
            onChange={handleChange}
            options={roles}
            renderInput={(params) => (
                <TextField 
                    {...params} 
                    variant="outlined" 
                    placeholder={placeholder}
                    size="small"
                />
            )}
            fullWidth
            size="small"
            autoHighlight
            autoComplete
            filterOptions={(options, state) => {
                const filtered = options.filter(option => 
                    option.toLowerCase().includes(state.inputValue.toLowerCase())
                );
                return filtered;
            }}
            disableListWrap
        />
    );
}

export { HSTRolesAutocomplete };
